import { render, staticRenderFns } from "./QuizQuestionScaleV2.vue?vue&type=template&id=71bf33ae&scoped=true"
import script from "./QuizQuestionScaleV2.vue?vue&type=script&lang=js"
export * from "./QuizQuestionScaleV2.vue?vue&type=script&lang=js"
import style0 from "./QuizQuestionScaleV2.vue?vue&type=style&index=0&id=71bf33ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf33ae",
  null
  
)

export default component.exports